export default "__VITE_ASSET__TYV5_54U__"